"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItem = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _index = require("../../styles/index.js");
var _index2 = require("../TypeListItem/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var ListItem = exports.ListItem = (0, _styledComponents["default"])(_index2.TypeListItem).attrs({
  variant: 'bodyMedium',
  condensed: true,
  listStyleReset: true
}).withConfig({
  displayName: "ListItem",
  componentId: "sc-36ddnp-0"
})(["", ";max-inline-size:100%;display:inline-block;&:not(:last-child){margin-inline-end:18px;}", " @media (min-width:", "){float:left;[dir='rtl'] &{float:right;}}"], (0, _index.rootStyle)(), _index.browserFocusReset, _encoreFoundation.screenSmMin);